<script setup lang="ts">
withDefaults(
  defineProps<{
    query: string | undefined
    nbHits: number
    showQuery: boolean
  }>(),
  {
    query: undefined,
    nbHits: 0,
    showQuery: true
  }
)
</script>

<template>
  <p v-if="!!query && showQuery">
    {{ `${nbHits} ${$t("filters.utils.desktopFiltersBar.results")}` }}
    <span class="pig-bold text-green-main">
      {{ query }}
    </span>
  </p>
  <p v-else class="number-of-results">
    {{ `${$t("filters.utils.desktopFiltersBar.products", nbHits ?? 0)}` }}
  </p>
</template>
